import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const TeamMemberSelection = (props) => {
  const {
    teamMembers,
    selectedTeamMemberDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedUserId,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the employee running the machine</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Choose the employee you want to be assigned to as the individual who initiated the turn</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-user"
            getOptionLabel={(option) => {
              return (option.firstName || option.lastName) ? `${option.firstName} ${option.lastName}` : option;
            }}
            options={teamMembers}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Team Member" />}
            value={selectedTeamMemberDisplay}
            isOptionEqualToValue={(option, value) => `${option.firstName} ${option.lastName}` === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedUserId,
          })}
          disabled={!selectedUserId}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default TeamMemberSelection;
